import type { CSSProperties } from 'react';
import {
  studyNoteUsesColumns,
  studyNoteHasFooterSpace,
  type StudyNote,
} from '../domain/classroom-study-note';
import { STUDY_NOTE_DECOR, studyNoteTone } from '../services/classroom-note-artwork';
import './classroom-study-note.css';

/** The editor snapshot remains selectable text; decorations never contain lesson content. */
export function ClassroomStudyNote({
  note,
  title = note.title,
  author,
  date,
}: {
  readonly note: StudyNote;
  readonly title?: string;
  readonly author?: string;
  readonly date?: string;
}) {
  const metadata = [author, date].filter(Boolean).join(' · ');
  return (
    <article className="classroom-study-note" aria-label="围棋课堂学习便签">
      <header className="classroom-study-note__header">
        <img className="classroom-study-note__header-art" src={STUDY_NOTE_DECOR.header} alt="" />
        <span className="classroom-study-note__eyebrow">课堂小记</span>
        <h2>
          {(title.trim() || note.title).split(/(?<=、)/u).map((part, index) => (
            <span key={index}>{part}</span>
          ))}
        </h2>
        {metadata ? <p className="classroom-study-note__metadata">{metadata}</p> : null}
      </header>
      <div className="classroom-study-note__body">
        {note.sections.map((section, index) => {
          const tone = studyNoteTone(index);
          return (
            <section
              className="classroom-study-note__section"
              key={index}
              style={{ '--ring-filter': tone.ring, '--brush-filter': tone.brush } as CSSProperties}
            >
              <div className="classroom-study-note__index">
                <span className="classroom-study-note__number" aria-hidden="true">
                  {String(index + 1).padStart(2, '0')}
                </span>
                {section.heading ? <h3>{section.heading}</h3> : null}
              </div>
              <ul
                className={
                  studyNoteUsesColumns(section) ? 'classroom-study-note__keywords' : undefined
                }
              >
                {section.items.map((text, item) => (
                  <li key={item}>{text}</li>
                ))}
              </ul>
            </section>
          );
        })}
      </div>
      <footer
        className={`classroom-study-note__footer${studyNoteHasFooterSpace(note) ? ' classroom-study-note__footer--tucked' : ''}`}
        aria-hidden="true"
      >
        <img className="classroom-study-note__swoosh" src={STUDY_NOTE_DECOR.swoosh} alt="" />
        <img src={STUDY_NOTE_DECOR.footer} alt="" />
      </footer>
    </article>
  );
}
